module.exports = __webpack_public_path__ + "img/transactions.f3ede56d.png";